export default "__VITE_ASSET__Cw68LoD7__"